import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteLocationNormalized } from 'vue-router'

// payment
const PaymentMethodsList = () => import('@/pages/payment/payment-methods/PaymentMethodsList.vue')
const AddPaymentMethod = () => import('@/pages/payment/payment-methods/AddPaymentMethod.vue')
const ChargeBalance = () => import('@/pages/payment/ChargeBalance.vue')
const ChargeBalanceOptions = () => import('@/pages/payment/ChargeBalanceOptions.vue')
const ChargeBalanceUsingFawry = () => import('@/pages/payment/ChargeBalanceUsingFawry.vue')
const ChargeBalanceUsingVoucher = () => import('@/pages/payment/ChargeBalanceUsingVoucher.vue')
const CheckoutForm = () => import('@/pages/payment/CheckoutForm.vue')
const CheckoutStatus = () => import('@/pages/payment/CheckoutStatus.vue')
const ApplePayPayment = () => import('@/pages/payment/ApplePayPayment.vue')

// tickets
const TicketsList = () => import('@/pages/tickets/TicketsList.vue')
const TicketDetails = () => import('@/pages/tickets/TicketDetails.vue')

// terms-and-conditions
const TermAndConditions = () => import('@/pages/terms-and-conditions/TermAndConditions.vue')
const PrivacyPage = () => import('@/pages/terms-and-conditions/PrivacyPage.vue')

// issue
const HelpOptions = () => import('@/pages/issue/HelpOptions.vue')
const CreateIssue = () => import('@/pages/issue/CreateIssue.vue')

// driver-earning
const TransactionsList = () => import('@/pages/driver-earning/TransactionsList.vue')
const RideDetails = () => import('@/pages/driver-earning/RideDetails.vue')

// driver-registration
const DriverRegistrationGuard = () =>
  import('@/pages/driver-registration/DriverRegistrationGuard.vue')
const PersonalInformation = () => import('@/pages/driver-registration/PersonalInformation.vue')
const DocumentsUploads = () => import('@/pages/driver-registration/DocumentsUploads.vue')

// driver-account
const DriverAccountOptions = () => import('@/pages/driver-account/DriverAccountOptions.vue')
const DriverSetting = () => import('@/pages/driver-setting/DriverSetting.vue')
const DriverVehicle = () => import('@/pages/driver-vehicle/DriverVehicle.vue')

// client-rides-history
const ClientRidesHistory = () => import('@/pages/client-rides-history/RidesHistory.vue')

// client-setting
const ClientSetting = () => import('@/pages/client-setting/ClientSetting.vue')

// client-wallet
const ClientWallet = () => import('@/pages/client-wallet/ClientWallet.vue')

// client-promos
const ClientPromotions = () => import('@/pages/client-promotions/ClientPromotions.vue')

// client-registration
const ClientRegistration = () => import('@/pages/client-registration/ClientRegistration.vue')

// user-profile
const UserProfile = () => import('@/pages/user-profile/UserProfile.vue')
const ChangePassword = () => import('@/pages/user-profile/ChangePassword.vue')
const ChangePhoneFirstStep = () => import('@/pages/user-profile/change-phone/FirstStep.vue')
const ChangePhoneSecondStep = () => import('@/pages/user-profile/change-phone/SecondStep.vue')
const ChangePhoneLastStep = () => import('@/pages/user-profile/change-phone/LastStep.vue')

// user-login
const UserPhone = () => import('@/pages/user-login/UserPhone.vue')
const UserPassword = () => import('@/pages/user-login/UserPassword.vue')
const ConfirmPhone = () => import('@/pages/user-login/ConfirmPhone.vue')
const ResetPassword = () => import('@/pages/user-login/ResetPassword.vue')
const allRoutes = [
  // terms-and-conditions
  {
    path: '/terms-and-condition',
    name: 'TermAndConditions',
    component: TermAndConditions
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyPage
  },
  // payment
  {
    path: '/apple-pay',
    name: 'ApplePayPayment',
    component: ApplePayPayment,
    props: (route: RouteLocationNormalized) => ({
      role: route.query.role
    })
  },
  {
    path: '/charge-balance',
    name: 'ChargeBalance',
    component: ChargeBalance,
    props: (route: RouteLocationNormalized) => ({
      operation: route.query.operation,
      paymentMethodId: route.query.paymentMethodId,
      role: route.query.role,
      accessToken: route.query.accessToken,
      userId: route.query.userId
    })
  },
  {
    path: '/charge-balance-options',
    name: 'ChargeBalanceOptions',
    component: ChargeBalanceOptions,
    props: (route: RouteLocationNormalized) => ({
      role: route.query.role,
      accessToken: route.query.accessToken,
      userId: route.query.userId
    })
  },
  // this is added for handle custom page in driver app
  {
    path: '/driver/getting-paid/balance-charge',
    name: 'ChargeBalanceForDriver',
    component: ChargeBalance
  },
  {
    path: '/balance-charge-using-fawry',
    name: 'ChargeBalanceUsingFawry',
    component: ChargeBalanceUsingFawry,
    props: (route: RouteLocationNormalized) => ({
      role: route.query.role,
      accessToken: route.query.accessToken,
      userId: route.query.userId
    })
  },
  {
    path: '/balance-charge-using-voucher',
    name: 'ChargeBalanceUsingVoucher',
    component: ChargeBalanceUsingVoucher,
    props: (route: RouteLocationNormalized) => ({
      role: route.query.role,
      accessToken: route.query.accessToken,
      userId: route.query.userId
    })
  },
  {
    path: '/payment-methods',
    name: 'PaymentMethods',
    component: PaymentMethodsList,
    props: (route: RouteLocationNormalized) => ({
      role: route.query.role
    })
  },
  {
    path: '/payment-methods/add',
    name: 'AddPaymentMethod',
    component: AddPaymentMethod,
    props: (route: RouteLocationNormalized) => ({
      role: route.query.role,
      accessToken: route.query.accessToken,
      userId: route.query.userId
    })
  },
  {
    path: '/checkout-form',
    name: 'CheckoutForm',
    component: CheckoutForm,
    props: (route: RouteLocationNormalized) => ({
      operation: route.query.operation,
      amount: route.query.amount,
      paymentMethodId: route.query.paymentMethodId,
      shopperResultUrl: route.query.shopperResultUrl,
      types: route.query.types,
      role: route.query.role,
      accessToken: route.query.accessToken,
      userId: route.query.userId
    })
  },
  {
    path: '/checkout-status/:operation/:paymentMethod/:role?/:accessToken?/:userId?',
    component: CheckoutStatus,
    props: (route: RouteLocationNormalized) => ({
      checkoutId: route.query.id,
      operation: route.params.operation,
      paymentMethod: route.params.paymentMethod,
      role: route.params.role,
      accessToken: route.params.accessToken,
      userId: route.params.userId
    })
  },
  // ticket
  {
    path: '/tickets',
    name: 'Tickets',
    component: TicketsList,
    props: (route: RouteLocationNormalized) => ({
      role: route.query.role
    })
  },
  {
    path: '/tickets/:id',
    name: 'TicketDetails',
    props: (route: RouteLocationNormalized) => ({
      ticketId: route.params.id,
      title: route.query.title,
      status: route.query.status,
      role: route.query.role
    }),
    component: TicketDetails
  },
  //driver-earning
  {
    path: '/driver/earning/',
    name: 'DriverTransactionsList',
    component: TransactionsList
  },
  {
    path: '/driver/earning/ride-details/:rideId',
    name: 'DriverRideDetails',
    component: RideDetails,
    props: (route: RouteLocationNormalized) => ({
      rideId: route.params.rideId
    })
  },
  // driver-account
  {
    path: '/driver/account',
    name: 'DriverAccountOptions',
    component: DriverAccountOptions
  },
  {
    path: '/driver/setting',
    name: 'DriverSetting',
    component: DriverSetting
  },
  {
    path: '/driver/vehicle',
    name: 'DriverVehicle',
    component: DriverVehicle
  },
  //driver-login
  {
    path: '/driver/login',
    name: 'DriverLogin',
    component: UserPhone,
    props: () => ({
      role: 'driver'
    })
  },
  {
    path: '/driver/login/enter-password',
    name: 'DriverLoginEnterPassword',
    component: UserPassword,
    props: (route: RouteLocationNormalized) => ({
      role: 'driver',
      phone: route.query.phone,
      dialCode: route.query.dialCode
    })
  },
  {
    path: '/driver/login/confirm-phone',
    name: 'DriverConfirmPhone',
    component: ConfirmPhone,
    props: (route: RouteLocationNormalized) => ({
      role: 'driver',
      operation: route.query.operation,
      phone: route.query.phone,
      dialCode: route.query.dialCode,
      otpResetTimeInSeconds: route.query.otpResetTimeInSeconds
    })
  },
  {
    path: '/driver/login/reset-password',
    name: 'DriverResetPassword',
    component: ResetPassword,
    props: (route: RouteLocationNormalized) => ({
      role: 'driver',
      accessToken: route.query.accessToken
    })
  },
  // driver-registration
  {
    path: '/driver/register/register-guard',
    name: 'DriverRegistrationGuard',
    component: DriverRegistrationGuard,
    props: (route: RouteLocationNormalized) => ({
      accessToken: route.query.accessToken,
      driverId: route.query.driverId
    })
  },
  {
    path: '/driver/register/personal-info',
    name: 'DriverRegistrationPersonalInfo',
    component: PersonalInformation,
    props: (route: RouteLocationNormalized) => ({
      accessToken: route.query.accessToken,
      dialCode: route.query.dialCode,
      phone: route.query.phone,
      country: route.query.country
    })
  },
  {
    path: '/driver/register/documents-upload',
    name: 'DriverRegistrationDocumentsUpload',
    component: DocumentsUploads,
    props: (route: RouteLocationNormalized) => ({
      accessToken: route.query.accessToken,
      driverId: route.query.driverId
    })
  },
  // driver-profile
  {
    path: '/driver/profile',
    name: 'DriverProfile',
    component: UserProfile,
    props: () => ({
      role: 'driver'
    })
  },
  {
    path: '/driver/profile/change-password',
    name: 'DriverChangePassword',
    component: ChangePassword,
    props: () => ({
      role: 'driver'
    })
  },
  {
    path: '/driver/profile/change-phone/first-step',
    name: 'DriverChangePhoneFirstStep',
    component: ChangePhoneFirstStep,
    props: () => ({
      role: 'driver'
    })
  },
  {
    path: '/driver/profile/change-phone/second-step',
    name: 'DriverChangePhoneSecondStep',
    component: ChangePhoneSecondStep,
    props: (route: RouteLocationNormalized) => ({
      password: route.query.password,
      role: 'driver'
    })
  },
  {
    path: '/driver/profile/change-phone/last-step',
    name: 'DriverChangePhoneLastStep',
    component: ChangePhoneLastStep,
    props: (route: RouteLocationNormalized) => ({
      role: 'driver',
      password: route.query.password,
      phone: route.query.phone,
      dialCode: route.query.dialCode,
      otpResetTimeInSeconds: route.query.otpResetTimeInSeconds
    })
  },
  // client-rides-history
  {
    path: '/client/rides-history',
    name: 'ClientRidesHistory',
    component: ClientRidesHistory
  },
  // client-settings
  {
    path: '/client/settings',
    name: 'ClientSetting',
    component: ClientSetting
  },
  // client-wallet
  {
    path: '/client/wallet',
    name: 'ClientWallet',
    component: ClientWallet
  },
  // client-promotions
  {
    path: '/client/promotions',
    name: 'ClientPromotions',
    component: ClientPromotions
  },
  //client-login
  {
    path: '/client/login',
    name: 'ClientLogin',
    component: UserPhone,
    props: () => ({
      role: 'client'
    })
  },
  {
    path: '/client/login/enter-password',
    name: 'ClientLoginEnterPassword',
    component: UserPassword,
    props: (route: RouteLocationNormalized) => ({
      role: 'client',
      phone: route.query.phone,
      dialCode: route.query.dialCode
    })
  },
  {
    path: '/client/login/confirm-phone',
    name: 'ClientConfirmPhone',
    component: ConfirmPhone,
    props: (route: RouteLocationNormalized) => ({
      role: 'client',
      operation: route.query.operation,
      phone: route.query.phone,
      dialCode: route.query.dialCode,
      otpResetTimeInSeconds: route.query.otpResetTimeInSeconds
    })
  },
  {
    path: '/client/login/reset-password',
    name: 'ClientResetPassword',
    component: ResetPassword,
    props: (route: RouteLocationNormalized) => ({
      role: 'client',
      accessToken: route.query.accessToken
    })
  },
  // client-registration
  {
    path: '/client/register',
    name: 'ClientRegistration',
    component: ClientRegistration,
    props: (route: RouteLocationNormalized) => ({
      accessToken: route.query.accessToken,
      dialCode: route.query.dialCode,
      phone: route.query.phone
    })
  },
  // client-profile
  {
    path: '/client/profile',
    name: 'ClientProfile',
    component: UserProfile,
    props: () => ({
      role: 'client'
    })
  },
  {
    path: '/client/profile/change-password',
    name: 'ClientChangePassword',
    component: ChangePassword,
    props: () => ({
      role: 'client'
    })
  },
  {
    path: '/client/profile/change-phone/first-step',
    name: 'ClientChangePhoneFirstStep',
    component: ChangePhoneFirstStep,
    props: () => ({
      role: 'client'
    })
  },
  {
    path: '/client/profile/change-phone/second-step',
    name: 'ClientChangePhoneSecondStep',
    component: ChangePhoneSecondStep,
    props: (route: RouteLocationNormalized) => ({
      password: route.query.password,
      role: 'client'
    })
  },
  {
    path: '/client/profile/change-phone/last-step',
    name: 'ClientChangePhoneLastStep',
    component: ChangePhoneLastStep,
    props: (route: RouteLocationNormalized) => ({
      role: 'client',
      password: route.query.password,
      phone: route.query.phone,
      dialCode: route.query.dialCode,
      otpResetTimeInSeconds: route.query.otpResetTimeInSeconds
    })
  },
  // issue
  {
    path: '/help/:type/:role',
    name: 'HelpOptions',
    component: HelpOptions,
    props: (route: RouteLocationNormalized) => ({
      type: route.params.type,
      role: route.params.role,
      rideId: route.query.rideId || null
    })
  },
  {
    path: '/driver/:subCategory/:code',
    name: 'CreateDriverIssue',
    component: CreateIssue,
    props: (route: RouteLocationNormalized) => ({
      category: 'driver',
      subCategory: route.params.subCategory,
      code: route.params.code,
      rideId: route.query.rideId || null
    })
  },
  {
    path: '/client/:subCategory/:code',
    name: 'CreateClientIssue',
    component: CreateIssue,
    props: (route: RouteLocationNormalized) => ({
      category: 'client',
      subCategory: route.params.subCategory,
      code: route.params.code,
      rideId: route.query.rideId || null
    })
  }
]
const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 }
  },
  routes: allRoutes
})

export default router
